<script>
  import { settings } from '../settings';
  export let key;
</script>

<div>{settings[key]}</div>
